import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  ViewChild,
  TemplateRef,
} from "@angular/core";
import { NzModalService } from "ng-zorro-antd/modal";
import { StoreService } from "@root/shared/service/store.service";
// import { MultiHouseCalendarService } from "@root/router/house/component/multi-house-calendar/multi-house-calendar.service";
// import { ArrangeCleanModalComponent } from '@root/router/task/task-clean/task-clean-house/arrange-clean-modal/arrange-clean-modal.component';
import { Router } from "@angular/router";
import _ from "lodash";
import { TranslateService } from "@root/shared/service/translate.service";
import { Parent } from "../multi-house-calendar.service";

@Component({
  selector: "host-status-left-house-group",
  templateUrl: "./status-left-house-group.component.html",
  styleUrls: ["./status-left-house-group.component.scss"],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusLeftHouseGroupComponent implements OnInit {
  @Input() showTitle = true;
  @Input() houseType: Parent;
  // @Input() housesCleanInfoMap = {};
  @ViewChild("SetCleanStatusTip", { static: true }) cleanStatusTip: TemplateRef<any>;
  @Output() onClickUpdateCleanStatus = new EventEmitter();

  private readonly storeCleanStatusKey = "hostex_confirm_no_cleaning";
  checked;
  modalRef;
  trackByHouse = (house) => house.id;

  constructor(
    public router: Router,
    // private modalService: NzModalService,
    private storeService: StoreService,
    // private calendarService: MultiHouseCalendarService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {}

  private isHideCleanStatusTip() {
    return this.storeService.get(this.storeCleanStatusKey, 2);
  }
  private updateLocalCleanStatus() {
    this.storeService.set(this.storeCleanStatusKey, this.checked, 2);
  }

  toPropertyDetailPage(params) {
    this.router.navigate(["/app/properties/detail"], params);
    // this.router.navigate(['/app/properties']);
    // setTimeout(() => {

    // }, 200)
  }

  toPropertyTypeDetailPage(params) {
    this.router.navigate(["/app/room_types/detail"], params);
    // this.router.navigate(['/app/properties']);
    // setTimeout(() => {

    // }, 200)
  }
  /**
   * 0 免打扫
   * 1 已保洁
   * 2 保洁中
   * 3 脏房
   */
  updateCleanStatus(id, status) {
    if (status === 0) {
      /** TODO: */
      // if (this.isHideCleanStatusTip()) {
      //   this.onClickUpdateCleanStatus.emit({ id, status });
      // } else {
      //   this.displayCleanStatusTip({ id, status });
      // }
    } else {
      this.onClickUpdateCleanStatus.emit({ id, status });
    }
  }
}
